import type {
  GetComponentStyle,
} from '@vtaits/react-paginator';

export const pageLinkGroupStyle: GetComponentStyle<unknown> = () => ({
  display: 'inline-block',
  verticalAlign: 'bottom',
});
